

















































import { Vue, Prop, Component, Emit } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

@Component({
  components: { DeleteMaterialModal, CustomButton }
})
export default class Modal extends Vue {
  modalId: string = this.generate();
  @Prop({ default: () => i18n.tc(LocalesFields.Notice) }) title?: string;
  @Prop({ default: true }) hideFooter?: boolean;
  @Prop({ default: true }) showControlButtons?: boolean;
  @Prop({ default: false }) buttonDisable?: boolean;
  @Prop({ default: "passive" }) buttonType?: string;
  @Prop({ default: true }) noCloseOnBackdrop?: boolean;
  @Prop({ default: () => i18n.tc(LocalesFields.Confirm) })
  buttonAcceptText?: string;
  @Prop({ default: "active" }) buttonAcceptType?: string;
  @Prop({ default: true }) showButtonCancel?: boolean;
  @Prop({ default: "passive" }) buttonCancelType?: string;
  @Prop({ default: () => i18n.tc(LocalesFields.Cancel) })
  buttonCancelText?: string;
  @Prop({ default: "md" }) size?: string;

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  showModal() {
    this.$emit("openAction");
    this.$bvModal.show(this.modalId);
  }

  hideModal() {
    this.$emit("cancel");
    this.$bvModal.hide(this.modalId);
  }

  @Emit()
  accept() {
    this.hideModal();
  }
}
